import _ from 'lodash'

const { API } = require('@/plugins/api')
const { hamiVuex } = require('@/store/base')

export const priceTableStore = hamiVuex.store({
  $name: 'priceTable',
  $state: {
    main_currency: 'CNY',
    tier_d: {},
    isLoaded: false,
  },
  UPSERT(result) {
    this.$patch({
      main_currency: result.main_currency,
      tier_d: result.tier_d,
      isLoaded: true,
    })
  },
  getPrice({ tier_key, currency }) {
    if (_.isNil(currency)) {
      currency = this.main_currency
    }
    return this.tier_d[tier_key]?.price_d[currency]?.price
  },
  doLoad: _.once(async function doLoad() {
    if (this.isLoaded) {
      return
    }
    const result = await API.call('merchant/price_table.get')
    this.UPSERT(result)
  }),
  async doUpsert(payload) {
    payload.main_currency = this.main_currency
    const result = await API.call('merchant/price_table.upsert', payload)
    this.UPSERT(result)
  },
})
